import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { logos } from '../assets';

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isExploraActive = location.pathname === '/explora' || location.pathname.startsWith('/explora/');
  const isProfesionalesActive = location.pathname.startsWith('/profesionales/');

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo" onClick={closeMenu}>
            <img src={logos.header} alt="GesOps LLC" className="logo-image" />
          </Link>
          
          <button className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu} aria-label="Toggle menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
          
          <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
            <Link 
              to="/" 
              className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              Inicio
            </Link>
           <div className="nav-item has-dropdown">
              <Link to="/explora" className={`nav-link ${isExploraActive ? 'active' : ''}`} onClick={closeMenu}>
                Explora
              </Link>
              <div className="nav-dropdown">
                <Link 
                  to="/explora/categorias" 
                  className={`nav-dropdown-item ${location.pathname === '/explora/categorias' ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  Categorías de Servicios
                </Link>
              </div>
            </div>

            <div className="nav-item has-dropdown">
              <span className={`nav-link ${isProfesionalesActive ? 'active' : ''}`}>
                Profesionales
              </span>
              <div className="nav-dropdown">
                <Link 
                  to="/profesionales/unete" 
                  className={`nav-dropdown-item ${location.pathname === '/profesionales/unete' ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  Únete al Directorio
                </Link>
                {/* <Link
                  to="/profesionales/planes"
                  className={`nav-dropdown-item ${location.pathname === '/profesionales/planes' ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  Planes del Directorio
                </Link> */}
                <Link 
                  to="/profesionales/back-offices" 
                  className={`nav-dropdown-item ${location.pathname === '/profesionales/back-offices' ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  Back Offices
                </Link>
              </div>
            </div>

            <Link 
              to="/quienes-somos" 
              className={`nav-link ${location.pathname === '/quienes-somos' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              Quiénes Somos
            </Link>
            {/* <Link
              to="/metodos-de-pago"
              className={`nav-link ${location.pathname === '/metodos-de-pago' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              Métodos de Pago
            </Link> */}
            <Link 
              to="/soporte" 
              className={`nav-link ${location.pathname === '/soporte' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              Contáctanos
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
